<template>
  <main>
    <div
      id="questions-true-false"
      class="p-5 bg-white rounded-md shadow-sm border flex flex-col gap-6 mb-5"
      v-for="(item, i) in store.form.items"
      :key="i"
    >
      <div id="header-item" class="flex flex-row justify-between">
        <p class="font-bold text-lg">Item {{ chooseLetter(i) }}*</p>

        <Button v-if="i > 0" class="btn btn-delete" @click="deleteItem(i)">
          <v-icon class="mr-1" name="md-delete" />
          <p class="text-[16px]">{{ $t("question.items.delete") }}</p>
        </Button>
      </div>

      <div id="enunciated-item">
        <Textarea
          id="question-input"
          :autoResize="true"
          rows="3"
          cols="30"
          :placeholder="t('question.prompt.items.empty')"
          v-model="store.form.items[i].answerText"
          :class="
            store.v$.form.items.$each.$response.$errors[i].answerText
              ?.length !== 0 && store.v$.form.$error
              ? 'p-invalid'
              : ''
          "
          :maxlength="999"
        />

        <Errors
          :errors="store.v$.form.items.$each.$response.$errors[i].answerText"
          :actualLength="store.form.items[i].answerText?.length"
          :maxLength="999"
        >
          <template #msg>
            {{ store.v$.form.$error ? t("validations.required") : "" }}
          </template>
        </Errors>
      </div>

      <div id="answer-item" class="flex flex-col gap-2">
        <span class="mb-2">{{
          $t("labels.generic", { pt: "Resposta", en: "Response" })
        }}</span>
        <SelectButton
          v-model="store.form.items[i].correctAnswer"
          class="custom-true-false"
          :options="options"
          optionLabel="label"
          optionValue="value"
        />
      </div>

      <div id="explanation-item" class="flex flex-col gap-2">
        <span>{{ t("question.prompt.items.description.title") }}</span>
        <Textarea
          id="question-input"
          :autoResize="true"
          rows="3"
          cols="30"
          :placeholder="t('question.prompt.items.empty')"
          v-model="store.form.items[i].answerDescription"
          :class="
            store.v$.form.items.$each.$response.$errors[i].answerDescription
              ?.length !== 0 && store.v$.form.$error
              ? 'p-invalid'
              : ''
          "
          :maxlength="999"
        />

        <Errors
          :errors="
            store.v$.form.items.$each.$response.$errors[i].answerDescription
          "
          :actualLength="store.form.items[i].answerDescription?.length"
          :maxLength="999"
        >
          <template #msg>
            {{ store.v$.form.$error ? t("validations.required") : "" }}
          </template>
        </Errors>
      </div>
    </div>

    <Button
      v-if="canAddItem"
      class="btn btn-outline"
      :label="t('question.items.create')"
      icon="pi pi-plus"
      @click="addItem"
    />
  </main>
</template>

<script lang="ts">
import { ItemQuestionTrueFalse } from "@/models/quiz.model";
import { useQuizQuestionsStore } from "@/store/quiz-questions";
import { computed, defineComponent } from "vue";
import { useI18n } from "vue-i18n";

export default defineComponent({
  name: "TrueOrFalseQuestion",
  data() {
    return {
      options: [
        {
          label: this.$t("labels.generic", { pt: "Verdadeiro", en: "True" }),
          value: true,
        },
        {
          label: this.$t("labels.generic", { pt: "Falso", en: "False" }),
          value: false,
        },
      ],
    };
  },
  methods: {
    chooseLetter(index): string {
      return String.fromCharCode(65 + index).toUpperCase();
    },
  },
  setup() {
    const { t } = useI18n();
    const store = useQuizQuestionsStore;

    const canAddItem = computed(() => store.getForm.items.length < 5);

    function addItem(): void {
      let form = store.getForm;
      form.items.push(new ItemQuestionTrueFalse());
      store.setForm(form);
    }

    function deleteItem(index): void {
      let form = store.getForm;
      form.items.splice(index, 1);
      store.setForm(form);
    }

    return { t, store, canAddItem, addItem, deleteItem };
  },
});
</script>

<style lang="scss">
.custom-true-false {
  .p-button-label {
    font-size: 16px;
    line-height: 20.08px;
    font-weight: 500;
    color: #3e4145;
    width: 150px;
    padding: 8px 0px;
  }

  .p-button {
    border: none;
    background-color: #fafafa !important;
    padding: 6px 4px;
  }

  .p-button.p-highlight {
    background-color: #fafafa !important;
    border: none;
    padding: 6px 4px;
  }

  .p-button.p-highlight .p-button-label {
    @apply ring-2 ring-h-primary-500;
    border-radius: 4px;
    background-color: #ffffff;
  }
}

.custom.p-selectbutton {
  max-width: fit-content;
  border: 1px solid #ebebeb;
  border-radius: 4px;
}
</style>
